import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  input: {
    background: theme.palette.common.white,
  },
})
